import React from 'react';
import { DropdownContainer } from 'shared/components/Dropdown/Dropdown';

interface BenchmarkDropdownProps {
  selected: string | undefined;
  options: string[];
  onChange: (benchmark: string) => void;
  isDisabled: boolean;
}

export const BenchmarkDropdown: React.FC<BenchmarkDropdownProps> = ({
  selected,
  options,
  onChange,
  isDisabled,
}) => {
  return (
    <DropdownContainer
      labelText="Benchmark"
      value={selected}
      options={options}
      onChange={onChange}
      disabled={isDisabled}
      verticalLayout
    />
  );
};
